import { ColumnData as CD } from 'ui/tableHeader';

export enum AnalyticsProvider {
  SEGMENT = 'Segment',
}

export enum AnalyticsRegion {
  US = 'US',
  EU = 'EU',
}

export type ThirdPartyIntegration = {
  id: number;
  projectId: number;
  apiToken: string;
  analyticsProvider: AnalyticsProvider;
  analyticsRegion: AnalyticsRegion;
  enabled: boolean;
};

export type ColumnData = CD & {
  RowCell: ({ row }: { row: ThirdPartyIntegration }) => React.ReactElement;
};
